import {
  PulseSearchProfileHitSchema as ContractPulseSearchProfileHitSchema,
  PulseSearchResponseSchema as ContractPulseSearchResponseSchema,
  PulseSearchTweetHitSchema as ContractPulseSearchTweetHitSchema,
} from '@sweetistics/contracts';
import { z as zod } from 'zod';
import { TweetSchema as FullTweetSchema } from '../../../../types/tweet';

export const SearchTweetHitSchema = ContractPulseSearchTweetHitSchema.transform((hit) => ({
  ...hit,
  full: hit.full ? FullTweetSchema.parse(hit.full) : undefined,
}));

export const SearchProfileHitSchema = ContractPulseSearchProfileHitSchema;

export const SearchResponseSchema = ContractPulseSearchResponseSchema.transform((payload) => ({
  ...payload,
  tweets: payload.tweets
    ? {
        ...payload.tweets,
        items: payload.tweets.items.map((item) => SearchTweetHitSchema.parse(item)),
      }
    : undefined,
  profiles: payload.profiles
    ? {
        ...payload.profiles,
        items: payload.profiles.items.map((item) => SearchProfileHitSchema.parse(item)),
      }
    : undefined,
}));

export const ReplyNetworkItemSchema = zod.object({
  username: zod.string(),
  name: zod.string(),
  profileImageUrl: zod.url().optional(),
  count: zod.number().int().min(0),
});

export const ReplyNetworkResponseSchema = zod.array(ReplyNetworkItemSchema);

export const UserInsightsResponseSchema = zod.object({
  timeOfDay: zod.array(
    zod.object({
      hour: zod.number().int().min(0).max(23),
      count: zod.number().int().min(0),
      original: zod.number().int().min(0),
      links: zod.number().int().min(0),
      replies: zod.number().int().min(0),
      quotes: zod.number().int().min(0),
    })
  ),
  tweetTypes: zod.object({
    original: zod.number().int().min(0),
    links: zod.number().int().min(0),
    replies: zod.number().int().min(0),
    quotes: zod.number().int().min(0),
  }),
  threadFrequency: zod.object({
    threadCount: zod.number().int().min(0),
    totalTweets: zod.number().int().min(0),
    percentage: zod.number().min(0),
  }),
  selfHype: zod.object({
    selfRetweetCount: zod.number().int().min(0),
    totalTweets: zod.number().int().min(0),
    percentage: zod.number().min(0),
  }),
  replyNetwork: ReplyNetworkResponseSchema,
  peakDays: zod.array(zod.object({ day: zod.string(), count: zod.number().int().min(0) })),
  topHashtags: zod.array(zod.object({ tag: zod.string(), count: zod.number().int().min(0) })),
  interactionSummary: zod.object({
    replyInbound: zod.number().int().min(0),
    replyOutbound: zod.number().int().min(0),
    retweetInbound: zod.number().int().min(0),
    retweetOutbound: zod.number().int().min(0),
    mentionInbound: zod.number().int().min(0),
    mentionOutbound: zod.number().int().min(0),
    totalInbound: zod.number().int().min(0),
    totalOutbound: zod.number().int().min(0),
    reciprocity: zod.number().min(0).nullable(),
    lastInboundAt: zod.date().nullable(),
    lastOutboundAt: zod.date().nullable(),
  }),
});

export {
  ProfileResponseSchema,
  ProfileSearchItemSchema,
  ProfileSearchResponseSchema,
  PulseSearchCapabilitySchema as SearchCapabilitySchema,
  PulseSearchRequestSchema as SearchRequestSchema,
} from '@sweetistics/contracts';
